import React from "react";
import { state } from "../client/store";
import { useSnapshot } from "valtio";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import referralCodeGenerator from "referral-code-generator";

function SectionOne() {
  const snap = useSnapshot(state);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleLogin = () => {
    if (validateData()) {
      toast.success("All Fields Validated", snap.toastOptions);
      state.isLoading = true;

      let userInfo = {
        data: {
          name: snap.name,
          email: snap.email,
          address: snap.address,
          phone: snap.phone,
          pin_code: snap.pin_code,
          city: snap.city,
          state: snap.state,
          ref_code: referralCodeGenerator.alpha("lowercase", 8),
        },
      };

      axios({
        method: "post",
        url: `${snap.baseUrl}/affiliate-users`,
        data: userInfo,
      })
        .then(function (response) {
          console.log(response);
          if (response.status === 200) {
            state.name = "";
            state.email = "";
            state.address = "";
            state.phone = 0;
            state.pin_code = 0;
            state.city = "";
            state.state = "";

            toast.success(
              "Registred Successfully 🎊, you will soon recive a mail from us.",
              snap.toastOptions
            );
            state.successModal = true;
          }
        })
        .catch(function (error) {
          // console.log(error.response);
          // console.log("ERROR DATA", error.response.data);
          if (error.response.status === 400) {
            console.log(error.response.data.error.message);

            toast.error(
              `😞 ${error.response.data.error.message}`,
              snap.toastOptions
            );
          }
        });
      state.isLoading = false;
    }
  };

  const validateData = () => {
    let isAllValid = true;
    toast.dismiss();

    if (snap.name === "" || snap.name.length === 0) {
      isAllValid = false;
      toast.error("Name Can not be blank", snap.toastOptions);
    }

    if (snap.email === "" || snap.email.length === 0) {
      isAllValid = false;
      toast.error("Email Can not be blank", snap.toastOptions);
    } else if (!validateEmail(snap.email)) {
      isAllValid = false;
      toast.error("Invalid Email", snap.toastOptions);
    }

    if (snap.phone === 0 || snap.phone.length === 0) {
      isAllValid = false;
      toast.error("Phone Can not be blank", snap.toastOptions);
    } else if (snap.phone.length != 10) {
      isAllValid = false;
      toast.error(
        "Phone Number needs to be at least 10 digits.",
        snap.toastOptions
      );
    }

    if (snap.address === "" || snap.address.length === 0) {
      isAllValid = false;
      toast.error("Address Can not be blank", snap.toastOptions);
    } else if (!snap.address.length > 8) {
      isAllValid = false;
      toast.error(
        "Address needs to be at least 8 characters.",
        snap.toastOptions
      );
    }

    if (snap.pin_code === 0 || snap.pin_code.length === 0) {
      isAllValid = false;
      toast.error("Pincode Can not be blank", snap.toastOptions);
    } else if (snap.pin_code.length != 6) {
      isAllValid = false;
      toast.error("Invalid Pincode", snap.toastOptions);
    }

    if (snap.city === "" || snap.city.length === 0) {
      isAllValid = false;
      toast.error("City Can not be blank", snap.toastOptions);
    }

    if (snap.state === "" || snap.state.length === 0) {
      isAllValid = false;
      toast.error("State Can not be blank", snap.toastOptions);
    }

    return isAllValid;
  };

  const setStateCity = (pincode) => {
    axios
      .get(`${snap.postalUrl}/${pincode}`)
      .then(function (response) {
        if (response.status === 200) {
          state.state = response.data[0].PostOffice[0].State;
          state.city = response.data[0].PostOffice[0].District;
        }
      })
      .catch(function (error) {
        // console.log(error.response);
        // console.log("ERROR DATA", error.response.data);
        if (error.response.status === 400) {
          console.log(error.response.data.error.message);

          toast.error(
            `😞 ${error.response.data.error.message}`,
            snap.toastOptions
          );
        }
      });
  };

  return (
    <section className="text-gray-600 body-font md:mx-24">
      <div className="container px-5 py-10 mx-auto flex flex-wrap items-center">
        <div className="lg:w-3/5 md:w-1/2 md:pr-16 lg:pr-0 pr-0">
          <h1 className="title-font font-bold text-4xl text-gray-900">
            Earn more than just commission.
          </h1>
          <p className="leading-relaxed mt-4">
            Increase your earning with Avish EduCom, access exclusive
            opportunities, and earn a commission through our referral program.
            Become our Affiliate.
          </p>
        </div>
        <div className="lg:w-2/6 md:w-1/2 bg-gray-100 rounded-lg p-8 flex flex-col md:ml-auto w-full mt-10 md:mt-0">
          <h2 className="text-gray-900 text-lg font-medium title-font mb-5">
            Register for affilite program.
          </h2>

          <div className="relative mb-2">
            <label className="leading-7 text-sm text-gray-600">Full Name</label>
            <input
              required
              onChange={(e) => {
                state.name = e.target.value;
              }}
              value={snap.name}
              type="text"
              className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>

          <div className="relative mb-2">
            <label className="leading-7 text-sm text-gray-600">Email</label>
            <input
              required
              onChange={(e) => {
                state.email = e.target.value;
              }}
              value={snap.email}
              type="email"
              id="email"
              name="email"
              className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>

          <div className="relative mb-2">
            <label className="leading-7 text-sm text-gray-600">Phone</label>
            <input
              required
              onChange={(e) => {
                state.phone = e.target.value;
              }}
              value={snap.phone}
              type="number"
              className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>

          <div className="relative mb-2">
            <label className="leading-7 text-sm text-gray-600">Address</label>
            <input
              required
              onChange={(e) => {
                state.address = e.target.value;
              }}
              value={snap.address}
              type="text"
              className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>

          <div className="relative mb-2">
            <label className="leading-7 text-sm text-gray-600">Pincode</label>
            <input
              required
              onChange={(e) => {
                state.pin_code = e.target.value;
                if (e.target.value.length == 6) {
                  setStateCity(e.target.value);
                }
              }}
              value={snap.pin_code}
              type="text"
              className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>

          <div className="flex gap-2">
            <div className="relative mb-2">
              <label className="leading-7 text-sm text-gray-600">City</label>
              <input
                required
                onChange={(e) => {
                  state.city = e.target.value;
                }}
                value={snap.city}
                type="text"
                className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
              />
            </div>

            <div className="relative mb-2">
              <label className="leading-7 text-sm text-gray-600">State</label>
              <input
                required
                onChange={(e) => {
                  state.state = e.target.value;
                }}
                value={snap.state}
                type="text"
                className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
              />
            </div>
          </div>

          <p className="text-sm text-red-700 mb-4">{snap.validationErrors}</p>

          <button
            onClick={handleLogin}
            className="text-yellow-400 bg-black border-0 py-2 px-8 focus:outline-none  rounded text-lg"
          >
            Submit
          </button>

          <p className="text-xs text-gray-500 mt-3 text-center">
            Awaiting New Opportunnities for you. 💸
          </p>
        </div>
      </div>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </section>
  );
}

export default SectionOne;
